import { GridColDef, gridDateComparator } from '@mui/x-data-grid';
import {
  getLocaleDate,
  getPatientAgeFilters,
  getPatientAssessmentFilters,
  getPatientEthnicityFilters,
  getPatientGenderFilters,
  getPatientRingSizeFilters,
} from 'utils';
import { getPatientBodyMassFilters } from 'utils/components/get-patient-body-mass-filters';

const COLUMNS: GridColDef[] = [
  {
    field: 'firstName',
    headerName: 'First Name',
    flex: 1,
    minWidth: 120,
  },
  {
    field: 'status',
    headerName: 'status',
    flex: 1,
    minWidth: 90,
  },
  {
    field: 'submittedTimestamp',
    headerName: 'Recording time',
    flex: 1,
    minWidth: 230,
    sortComparator: gridDateComparator,
    filterable: false,
    valueFormatter: (params) => getLocaleDate(params?.value),
    type: 'date',
  },
  {
    field: 'updatedAt',
    headerName: 'updated',
    flex: 1,
    minWidth: 230,
    valueGetter: ({ value }) => {
      if (value) {
        return new Date(value.substring(0, 23) + 'Z');
      }

      return null;
    },
    sortComparator: gridDateComparator,
    filterable: false,
    valueFormatter: (params) => getLocaleDate(params?.value),
    type: 'date',
  },
  {
    field: 'medicalRecordNumber',
    headerName: 'MRN',
    flex: 1,
    minWidth: 15,
  },
  {
    field: 'age',
    headerName: 'Age',
    flex: 1,
    minWidth: 15,
    filterOperators: getPatientAgeFilters(),
  },
  {
    field: 'gender',
    headerName: 'Gender',
    flex: 1,
    width: 70,
    filterOperators: getPatientGenderFilters(),
  },
  {
    field: 'ethnicity',
    headerName: 'Hispanic',
    flex: 1,
    minWidth: 20,
    filterOperators: getPatientEthnicityFilters(),
  },
  {
    field: 'assessment',
    headerName: 'Assessment',
    minWidth: 50,
    flex: 1,
    sortable: false,
    filterOperators: getPatientAssessmentFilters(),
  },
  {
    field: 'race',
    headerName: 'Race',
    flex: 1,
    minWidth: 150,
  },
  {
    field: 'bmi',
    headerName: 'BMI',
    flex: 1,
    minWidth: 20,
    filterOperators: getPatientBodyMassFilters(),
    valueFormatter: (params) =>
      params.value && typeof params.value === 'number' ? (params.value * 100).toFixed(1) : undefined,
  },
  {
    field: 'avatarUri',
    headerName: 'Practice',
    flex: 1,
    minWidth: 20,
  },
  {
    field: 'study',
    headerName: 'Successful',
    flex: 1,
    minWidth: 150,
  },
  {
    field: 'size',
    headerName: 'Size',
    flex: 1,
    minWidth: 50,
    filterOperators: getPatientRingSizeFilters(),
  },
];

const INITIAL_RECORDS_LIMIT = 10;

export { COLUMNS, INITIAL_RECORDS_LIMIT };
